import { render } from "./sandGradeCollapseGroup.vue?vue&type=template&id=67e8c7ba&scoped=true"
import script from "./sandGradeCollapseGroup.vue?vue&type=script&lang=js"
export * from "./sandGradeCollapseGroup.vue?vue&type=script&lang=js"

import "./sandGradeCollapseGroup.vue?vue&type=style&index=0&id=67e8c7ba&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e8c7ba"]])

export default __exports__